import ApplicationController from "./application_controller";

export default class DismissableController extends ApplicationController {
    dismiss() {
        this.element.remove()
    }
}
